import { render, staticRenderFns } from "./HeaderHelp.vue?vue&type=template&id=b4547b1c&"
import script from "./HeaderHelp.vue?vue&type=script&lang=ts&"
export * from "./HeaderHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports